export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10415.3ba1595b.jpg";